/* istanbul ignore file */
import React from "react";
import { GlobalStyles } from "@mui/material";

const headingsStyle = {
  margin: "0",
  color: "#000"
}

const globalStyles = {
  body: {
    backgroundColor: "#fff",
    fontFamily: "Lato",
    fontSize: "14px",
    color: "#595959"
  },
  h1: {
    ...headingsStyle,
    fontSize: "30px"
  },
  h2: {
    ...headingsStyle,
    fontSize: "20px"
  },
  h3: {
    ...headingsStyle,
    fontSize: "18px"
  },
  h4: {
    ...headingsStyle,
    fontSize: "14px"
  },
  h5: {
    ...headingsStyle,
    fontSize: "12px"
  },
  h6: {
    ...headingsStyle,
    fontSize: "10px"
  },
  label: {
    fontWeight: "600",
    display: "inline-block",
    marginBottom: "2px"
  },
  '[class^="t-"], [class*=" t-"]': {
    fontSize: "20px"
  },
  ".icon-text-holder": {
    "> i, > span, > a": {
      display: "inline-block",
      verticalAlign: "middle",
    },
    "> span, > a": {
      marginTop: "-1px"
    },
    "> i": {
      margin: "-3px 5px 0 0"
    },
  },
  //MUI Lab Components
  ".MuiTabPanel-root": {
    padding: "12px!important"
  }
};

const GlobalStylesComponent = <GlobalStyles styles={globalStyles} />;

export default GlobalStylesComponent;